var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-transfer',{attrs:{"dataSource":_vm.dbList,"titles":[_vm.$t('db.text_193'), _vm.$t('db.text_194')],"listStyle":{
      width: '332px',
      height: '332px',
      },"render":_vm.renderItem,"targetKeys":_vm.targetKeys},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }